import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { QuestionsComponent } from './questions.component';
import { DiariesListComponent } from './routes/diaries-list/diaries-list.component';
import { PatientsListComponent } from './routes/patients-list/patients-list.component';
import { QuestionsListComponent } from './routes/questions-list/questions-list.component';
import { ScheduledTaskComponent } from './routes/scheduled-task/scheduled-task.component';

const routes: Routes = [
  {
    path: '',
    component: QuestionsComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'patients' },
      {
        path: 'list',
        component: QuestionsListComponent,
        loadChildren: () =>
          import('./routes/questions-list/questions-list.module').then(
            (m) => m.QuestionsListModule,
          ),
      },
      {
        path: 'diary',
        component: DiariesListComponent,
        loadChildren: () =>
          import('./routes/diaries-list/diaries-list.module').then(
            (m) => m.DiariesListModule,
          ),
      },
      {
        path: 'patients',
        component: PatientsListComponent,
        loadChildren: () =>
          import('./routes/patients-list/patients-list.module').then(
            (m) => m.PatientsListModule,
          ),
      },
      {
        path: 'scheduled-task',
        component: ScheduledTaskComponent,
        loadChildren: () =>
          import('./routes/scheduled-task/scheduled-task.module').then(
            (m) => m.ScheduledTaskModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuestionsRoutingModule {}
